export default __webpack_public_path__ + "static/media/layer1.7d379d0d.svg";